/* 居宅訪問 */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as AppUserActions from '../actions/AppUser';
import * as HeaderActions from '../actions/Header';
import HomeVisit from '../components/HomeVisit';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
    appUser: state.appUser,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    appUserActions : bindActionCreators(AppUserActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeVisit as any);



// WEBPACK FOOTER //
// ./src/containers/HomeVisit.tsx